const updatePreviousLocation = (previousLocation) => ({
  type: 'UPDATE_PREVIOUS_LOCATION',
  previousLocation,
});

export default updatePreviousLocation;
